import type { CheckPriceInput } from "services/apiSpeedShipping";
import type { SpeedMerchantItem } from "services/merchantApi";

export function pickDefaultSpeedMerchant(
  list: SpeedMerchantItem[] | undefined
): SpeedMerchantItem | undefined {
  if (!list?.length) return undefined;
  const active = list.filter((m) => m.is_active && !m.is_delete);
  return active.find((m) => m.is_default) ?? active[0];
}

export function merchantToCheckPriceOrigin(
  merchant: SpeedMerchantItem
): CheckPriceInput["origin"] {
  return {
    county: merchant.county || "",
    city: merchant.city || "",
    state: merchant.state || "",
    postcode: merchant.postcode || "",
  };
}

export type PickupAddressDisplay = {
  contactName: string;
  addressLine: string;
  county: string;
  city: string;
  state: string;
  postcode: string;
  phone: string;
  email: string;
};

export function formatPickupAddressDisplay(
  merchant: SpeedMerchantItem
): PickupAddressDisplay {
  const contactName = merchant.pickup_name?.trim() || "-";
  return {
    contactName,
    addressLine: merchant.address || "-",
    county: merchant.county?.trim() || "-",
    city: merchant.city?.trim() || "-",
    state: merchant.state?.trim() || "-",
    postcode: merchant.postcode?.trim() || "-",
    phone: merchant.mobile1 || "-",
    email: merchant.email || "-",
  };
}

/** ที่อยู่รับสินค้าแบบบรรทัดเดียว — สำหรับ Modal สรุป */
export function formatPickupFullAddress(merchant: SpeedMerchantItem): string {
  const d = formatPickupAddressDisplay(merchant);
  const parts = [
    d.addressLine !== "-" ? d.addressLine : "",
    d.county !== "-" ? d.county : "",
    d.city !== "-" ? d.city : "",
    d.state !== "-" ? d.state : "",
    d.postcode !== "-" ? d.postcode : "",
  ].filter(Boolean);
  return parts.join(" ") || "-";
}

export function formatDestinationFullAddress(parts: {
  address?: string;
  subDistrict?: string;
  district?: string;
  province?: string;
  postcode?: string;
}): string {
  const line = [
    parts.address?.trim(),
    parts.subDistrict?.trim(),
    parts.district?.trim(),
    parts.province?.trim(),
    parts.postcode?.trim(),
  ].filter(Boolean);
  return line.join(" ") || "-";
}
